import { InputLabel } from '@material-ui/core';
import React from 'react';
import { useMediaQuery } from 'react-responsive';

const { MOBILE } = window.AppConfig.SCREEN_SIZE;

export default function InputLabelMobile({
	label = '',
	id = '',
	className = '',
	shrink = false,
	placeholder = '',
	...otherProps
}) {
	const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });

	if (isMobile) {
		return (
			<InputLabel
				{...otherProps}
				id={id}
				shrink={shrink}
				className={`inputlabel ${className}`}
				placeholder={placeholder}>
				{label}
			</InputLabel>
		);
	}
	return null;
}
